import { type FunctionalComponent, h } from '@stencil/core';
import type { IGeneralFilters } from '../types/subcomponents-types.type';
import { HorizontalFilters } from './horizontal-filter/horizontal-filters';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

export const Filters: FunctionalComponent<IGeneralFilters> = ({ ...props }) => {
    const {newFacetsLogicConfig} = props;
    const headerAdditionalComponentFallback = {element: (e) => '' as unknown as HTMLElement, elementHeight: 0};
    const headerAdditionalComponentsWithFallback = props.headerAdditionalComponents ? props.headerAdditionalComponents : headerAdditionalComponentFallback;

    if(newFacetsLogicConfig && newFacetsLogicConfig.isMobileFiltering && props.mobileView) {
      return (<uiaas-search-facets-build-wrapper
        hiddenFacets={props.hiddenFacets}
        tabName={props.tabName}
        labelProvider={props.labelProvider as labelProviderInterface}
        rtl={props.rtl}
        coseRequestService={props.coseRequestService}
        facetsService={props.facetsService}
        totalHitsProp={props.queryResult.stats.totalHits.toString()}
        facetsLogicConfig={newFacetsLogicConfig.newLogicConfig}
        isMobileFiltering={newFacetsLogicConfig.isMobileFiltering}
        headerAdditionalComponents={headerAdditionalComponentsWithFallback}
        facetsLabel={
          props.mobileFilterButton && props.mobileView
            ? ''
            : props.labelProvider(
              'tab.filter-by',
              'Filter by'
            )
        }
      ></uiaas-search-facets-build-wrapper>);
    }

    if(newFacetsLogicConfig && newFacetsLogicConfig.isNewFacetsLogic && !props.mobileView) {
      return (<uiaas-search-facets-build-wrapper
        hiddenFacets={props.hiddenFacets}
        tabName={props.tabName}
        labelProvider={props.labelProvider as labelProviderInterface}
        rtl={props.rtl}
        query={props.query}
        coseRequestService={props.coseRequestService}
        facetsService={props.facetsService}
        totalHitsProp={props.queryResult.stats.totalHits.toString()}
        isNewFacetsLogic={newFacetsLogicConfig.isNewFacetsLogic}
        facetsLogicConfig={newFacetsLogicConfig.newLogicConfig}
        filterPremiumIconUniqueId={props.filterPremiumIconUniqueId}
        collapseCharactericticsBtnType={props.collapseCharactericticsBtnType}
        facetsLabel={
          props.mobileFilterButton && props.mobileView
            ? ''
            : props.labelProvider(
              'tab.filter-by',
              'Filter by'
            )
        }
      ></uiaas-search-facets-build-wrapper>);
    }
    return (
      <div class={`filters__container${props.horizontalFilterPanel ? '-horizontal' : ''}`}>
        <uiaas-search-facets
          tab-id={props.idProp}
          facets-label={
            props.mobileFilterButton && props.mobileView
              ? ''
              : props.labelProvider(
                'tab.filter-by',
                'Filter by'
              )
          }
          facets={props.limitedFacets}
          facetStateCose={props.facetStateCose}
          labelProvider={(label, replacement) =>
            props.labelProvider(
              props.tabName + '.facet.' + label,
              replacement
            )
          }
          openedFacets={props.openedFacets}
          mobileView={props.mobileView}
          noHeaderFacets={props.noHeaderFacets}
          commonFilterTranslations={(e, f) =>
            props.labelProvider(e, f)
          }
          itemsLimit={props.filtersItemsLimit}
          reflectedState={props.reflectedState}
          disableFiltersOnLoading={props.disableFiltersOnLoading}
          rtl={props.rtl}
          horizontalFilterPanel={props.horizontalFilterPanel}
          hide-facet-title={props.horizontalFilterPanel}
          searchFacetsValuesToRemove={props.searchFacetsValuesToRemove}
          enforcedFilters={props.enforcedFilters}
          searchableInputFilter={props.searchableInputFilter}
          scrollToTop={props.scrollToTop}
          productCatalog={props.productCatalog}
          hiddenFacets={props.hiddenFacets}
          defaultQuartzColor={props.defaultQuartzColor}
        />
        <HorizontalFilters
          filtersChips={props.filtersChips}
          facetChanged={props.facetChanged}
          horizontalFilterPanel={props.horizontalFilterPanel}
          labelProvider={(e, f) => props.labelProvider(e, f)}
          reflectedState={props.reflectedState}
          disableFiltersOnLoading={props.disableFiltersOnLoading}
        />
      </div>
    );
};
